<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center mb-2">
        <h1>All Locations</h1>
          <v-alert v-if="locations == false" color="info" icon="new_releases" :value="true">
            There are no locations.
          </v-alert>
      </v-flex>
      <v-flex xs10 sm11 md11 align-content-space-between mt-4 mb-0 ml-0 mr-0>
        <v-card class="info" v-for="(item, index) in locations" v-bind:key="item.locationId"  :to="'/locations/' + item.locationId">
          <v-list class="listItems">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <v-icon left>location_on</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.locationName"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat ripple>
                    <v-icon v-bind:color="item.active ? 'grey' : 'grey'">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <!--
                <v-list-tile-action v-if="userIsAuthenticated" class="orange">
                  <template>
                    <app-edit-location-dialog :location="location(index)"></app-edit-location-dialog>
                  </template>
                </v-list-tile-action>
                <v-list-tile-action v-if="userIsAuthenticated" class="red darken-3">
                  <v-btn dark flat class="red darken-3 pa-2" @click="onDeleteLocation(item)">
                    <v-icon dark class="text--lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              -->
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs2 sm1 md1 ml-0 mr-0 mb-0 mt-4 justify-center v-if="userIsAuthenticated">
        <v-card class="info" v-for="(item2, index2) in locations" v-bind:key="item2.locationId">
          <v-list class="listItems pa-0">
              <v-list-tile class="pa-2">
        				<app-edit-location-dialog :location="location(index2)"></app-edit-location-dialog>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 mb-4 v-if="userIsAuthenticated">
        <v-card :to="'/location/new'">
          <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
            Add Location
            <v-icon class="text-xs-right">add</v-icon>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    locations () {
      return this.$store.getters.loadedLocations
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    location (index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedLocation(this.locations[index].locationId))
      return this.$store.getters.loadedLocation(this.locations[index].locationId)
    },
    onDeleteLocation (location) {
      console.log('Delete this: ' + JSON.stringify(location))
      this.$store.dispatch('deleteLocationData', location)
      this.$router.push('/locations')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Locations.vue?4b5b5ac8